import React from 'react';

import { ANONYM_USER_ROUTE } from '@/App/AppRoutes/constants';
import type { LayoutRouteBaseConfig } from '@/App/AppRoutes/types';
import { ProtectedLayout } from '@/components/layout/ProtectedLayout';

export const ProtectedLayoutRouteBase: LayoutRouteBaseConfig = {
  key: 'protected-layout',
  path: '/dashboard',
  element: <ProtectedLayout anonymousUserRoute={ANONYM_USER_ROUTE} />,
};
